import {useContext, useEffect} from 'react';
import {useLocation} from "react-router-dom";
import {API, graphqlOperation} from "aws-amplify";
import {Mortgages} from "./providers/MortgagesProvider";

export const createAdminBackendUserPageVisit = /* GraphQL */`

    mutation CreateAdminBackendUserPageVisit(
        $input: CreateAdminBackendUserPageVisitInput!
        $condition: ModelAdminBackendUserPageVisitConditionInput
    ) {
        createAdminBackendUserPageVisit(input: $input, condition: $condition) {
            id
            backendUserID
            page
            mortgageID
            stage
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
        }
    }
`;

function RouteLogger({sub}) {
    const location = useLocation();
    const {ALL} = useContext(Mortgages)
    const logVisit = async () => {
        if (sub) {
            const input = {
                backendUserID: sub,
                page: location.pathname,
            }
            if (location.pathname.startsWith('/mortgage/')) {
                const mortgageID = location.pathname.split('/')[2]
                if (mortgageID) {
                    input.mortgageID = mortgageID
                }
                const m = ALL.find(m => m.id === mortgageID)
                if (m && m.applicationStage) {
                    input.stage = m.applicationStage
                }
            }

            await API.graphql(graphqlOperation(createAdminBackendUserPageVisit, {input}))
        }
    }

    useEffect(() => {
        if (sub !== '9b209290-cefe-4cfd-ade2-11d6794c66a1') { // stevo
            logVisit()
        }
    }, [location, sub]);

    return null; // nothing to render
}

export default RouteLogger;